// Project
import { type PlatformLanguage } from './types/i18n'

const DATE_FORMATS_BY_LANG: Record<PlatformLanguage, string> = {
  es: 'D [de] MMMM, YYYY',
  en: 'MMMM D, YYYY',
  pt: 'D [de] MMMM, YYYY',
  'pt-BR': 'D [de] MMMM, YYYY',
  ht: 'D [de] MMMM, YYYY',
  bg: 'D MMMM YYYY г.',
  sk: 'D. MMMM YYYY',
  ro: 'D. MMMM YYYY',
  ar: 'D MMMM YYYY',
}

const MONTH_FORMATS_BY_LANG: Record<PlatformLanguage, string> = {
  es: 'D [de] MMMM',
  en: 'MMMM D',
  pt: 'D [de] MMMM',
  'pt-BR': 'D [de] MMMM',
  ht: 'D [de] MMMM',
  bg: 'D MMMM',
  sk: 'D. MMMM',
  ro: 'D. MMMM',
  ar: 'D MMMM',
}

/**
 * @deprecated Use getDateMaskFormat() from format-date.ts instead
 */
const DATE_MASK_BY_LANG: Record<PlatformLanguage, string> = {
  es: 'DD/MM/YYYY',
  en: 'MM/DD/YYYY',
  pt: 'DD/MM/YYYY',
  'pt-BR': 'DD/MM/YYYY',
  ht: 'DD/MM/YYYY',
  bg: 'DD.MM.YYYY',
  sk: 'DD.MM.YYYY',
  ro: 'DD.MM.YYYY',
  ar: 'DD/MM/YYYY',
}

const DATE_HOUR_BY_LANG: Record<PlatformLanguage, string> = {
  es: 'MMM DD, yyyy HH:mm',
  en: 'MMM D, yyyy HH:mm',
  pt: 'MMM DD, yyyy HH:mm',
  'pt-BR': 'MMM DD, yyyy HH:mm',
  ht: 'MMM DD, yyyy HH:mm',
  bg: 'MMM DD, yyyy HH:mm',
  sk: 'MMM DD, yyyy HH:mm',
  ro: 'MMM DD, yyyy HH:mm',
  ar: 'MMM DD, yyyy HH:mm',
}

/**
 * @deprecated Use format-date.ts instead
 */
const getDateFormatByLocale = (lang: PlatformLanguage) => {
  const format = DATE_FORMATS_BY_LANG[lang]
  return format || DATE_FORMATS_BY_LANG.en
}

/**
 * @deprecated Use format-date.ts instead
 */
const getMonthFormatByLocale = lang => {
  const format = MONTH_FORMATS_BY_LANG[lang]
  return format || MONTH_FORMATS_BY_LANG.en
}

/**
 * @deprecated Use format-date.ts instead
 */
const getDateMaskByLocale = lang => {
  const mask = DATE_MASK_BY_LANG[lang]
  return mask || DATE_MASK_BY_LANG.en
}

/**
 * @deprecated Use format-date.ts instead
 */
const getDateHourByLocale = lang => {
  const format = DATE_HOUR_BY_LANG[lang]
  return format || DATE_HOUR_BY_LANG.es
}

// Calc. to show update data in local time
/**
 * @deprecated Use format-date.ts instead
 */
const serverDateToLocalDate = serverDate => {
  const date = new Date(serverDate)
  date.setHours(date.getHours(), date.getMinutes() - date.getTimezoneOffset())
  return date
}

export {
  getMonthFormatByLocale,
  getDateFormatByLocale,
  getDateMaskByLocale,
  getDateHourByLocale,
  DATE_FORMATS_BY_LANG,
  serverDateToLocalDate,
}
